import axios from "axios";
import { signOutSuccess } from "store/slices/authSlice";
import store from "../store";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { notification } from "antd";

import Utils from "utils";

const unauthorizedCode = [400, 401, 403];

const service = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
  timeout: 60000,
});

// Config
const TOKEN_PAYLOAD_KEY = "authorization";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    let notificationParam = {
      message: "",
      description: Utils.getErrorMessages(error),
    };

    // Remove token and redirect
    if (unauthorizedCode.includes(error.response?.status)) {
      notificationParam.message = "Authentication Fail";
      localStorage.removeItem(AUTH_TOKEN);

      store.dispatch(signOutSuccess());
    }

    if (error.response?.status === 404) {
      notificationParam.message = "Not Found";
    }

    if (error.response?.status === 500) {
      notificationParam.message = "Internal Server Error";
    }

    if (error.response?.status === 508) {
      notificationParam.message = "Time Out";
    }

    // 백엔드에서 전달한 상세 에러 메시지가 있으면 그대로 전달
    if (error.response?.data?.error) {
      notificationParam.message = error.response?.data?.error;
    }
    
    if (error.response?.data?.message) {
      notificationParam.message = error.response?.data?.message;
    }

    notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
